import { useState } from "react";
import useCustomerHook from "../../customers/useCustomerHook";
import alertify from "alertifyjs";

export default function SendToCustomerModal({ invoice }) {
  const { FetchCustomersDocuments } = useCustomerHook();
  const { customersDocuments } = FetchCustomersDocuments(invoice?.customer?.id);
  console.log(customersDocuments);
  const [documentIds, setDocuments] = useState();
  const [loading, setLoading] = useState(false);
  const docsToShow = customersDocuments;

  return (
    <div
      className="modal custom-modal fade pay-modal"
      id="paynow_modal"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <div className="form-header modal-header-title text-start mb-0">
              <h4 className="modal-title">
                Invoice <span>#{invoice?.invoice_number}</span>
              </h4>
            </div>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form action="#">
            <div className="modal-body ">
              <div className="row">
                <div className="payment-heading">
                  <h5>Select Attached Documents</h5>
                </div>
                <div
                  className="input-block mb-3 paynow-tab"
                  style={{
                    display: "flex",
                    gap: 20,
                    overflow: "scroll",
                  }}
                >
                  {docsToShow && docsToShow.length > 0 ? (
                    docsToShow.map((item) => {
                      const isSelected = (documentIds || []).includes(item?.id);
                      return (
                        <div
                          key={item.id}
                          style={{
                            height: "fit-content",
                            width: 100,
                            border: isSelected
                              ? "2px solid green"
                              : "1px solid lightgray",
                            background: isSelected ? "#e6ffe6" : "white",
                            cursor: "pointer",
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom: 8,
                          }}
                          onClick={() => {
                            setDocuments((prev) => {
                              const docs = prev || [];
                              if (docs.includes(item?.id)) {
                                return docs.filter((id) => id !== item?.id);
                              } else {
                                return [...docs, item?.id];
                              }
                            });
                          }}
                        >
                          <div className="container">
                            <svg
                              width="80px"
                              height="80px"
                              viewBox="0 0 1024 1024"
                              className="icon"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M719.8 651.8m-10 0a10 10 0 1 0 20 0 10 10 0 1 0-20 0Z"
                                fill="#E73B37"
                              />
                              <path
                                d="M512.1 64H172v896h680V385.6L512.1 64z m278.8 324.3h-280v-265l280 265zM808 916H216V108h278.6l0.2 0.2v296.2h312.9l0.2 0.2V916z"
                                fill="#39393A"
                              />
                              <path
                                d="M280.5 530h325.9v16H280.5z"
                                fill="#39393A"
                              />
                              <path
                                d="M639.5 530h90.2v16h-90.2z"
                                fill="#E73B37"
                              />
                              <path
                                d="M403.5 641.8h277v16h-277z"
                                fill="#39393A"
                              />
                              <path
                                d="M280.6 641.8h91.2v16h-91.2z"
                                fill="#E73B37"
                              />
                              <path
                                d="M279.9 753.7h326.5v16H279.9z"
                                fill="#39393A"
                              />
                              <path
                                d="M655.8 753.7h73.9v16h-73.9z"
                                fill="#E73B37"
                              />
                            </svg>
                          </div>
                          <div
                            style={{
                              backgroundColor: "lightgray",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            {item?.name}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div>No documents attached.</div>
                  )}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-back cancel-btn me-2"
              >
                Cancel
              </button>
              <button
                className="btn btn-primary paid-continue-btn"
                disabled={loading}
                onClick={() => {
                  setLoading(true);
                  fetch(`/invoice/${invoice.id}/send-email/`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      "X-CSRFToken": document.cookie
                        .split("; ")
                        .find((row) => row.startsWith("csrftoken="))
                        ?.split("=")[1],
                    },
                    credentials: "include",
                    body: JSON.stringify({ documents_selected: documentIds }),
                  })
                    .then((response) => response.json())
                    .then((data) => {
                      console.log("Invoice added successfully:", data);
                      alertify.set("notifier", "position", "top-right");
                      alertify.success("Invoice sent to customer");
                      document
                        .querySelector('[data-bs-dismiss="modal"]')
                        ?.click();
                    })
                    .catch((error) => {
                      setLoading(false);
                      console.error("Error adding invoice:", error);
                    });
                }}
              >
                Send now
                {loading && (
                  <span
                    className="spinner-border spinner-border-sm ms-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
